import { selectEmvPaymentModuleState } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-selectors';
import { EMVService } from '@ticketmaster/tm1pos-web-shared/payment/EMVService';
import { useSelector } from 'react-redux';
import { PaymentMethodInput } from '../../../__generated__/graphql';
import { selectCartTotals } from '../../App/selectors';
import { selectCurrentEventPaymentPermissions } from '../components/form/checkout-selectors';
import {
  authOffCreditCard,
  otherPayment,
  pdgCreditCard,
  selectOtherPaymentCategory,
  tmdsCreditCard,
} from './payment-mappers';
import type { PaymentInput } from '../../../__generated__/graphql';
import type { CheckoutReduxForm } from '../types/checkout-redux-form';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const usePaymentMapper = () => {
  const pricing = useSelector(selectCartTotals);
  const emv = useSelector(selectEmvPaymentModuleState);
  const isAuthorizationOff = !useSelector(selectCurrentEventPaymentPermissions)?.mustAuthorizeCards;
  const otherPaymentCategory = useSelector(selectOtherPaymentCategory);

  return (form: CheckoutReduxForm, emvTransaction?: EmvTransaction): PaymentInput => {
    if (form.paymentMethod === 'Card') {
      const payment: PaymentInput = {
        amount: pricing.total.amount,
        method: PaymentMethodInput.CreditCard,
      };
      if (emvTransaction) {
        if (emv.emvMode === EMVService.Tmds) {
          return {
            ...payment,
            creditCard: tmdsCreditCard(emvTransaction),
          };
        }
        if (emv.emvMode === EMVService.Pdg) {
          return {
            ...payment,
            creditCard: pdgCreditCard(emvTransaction),
          };
        }
      }
      if (isAuthorizationOff) {
        return {
          ...payment,
          creditCard: authOffCreditCard(form),
        };
      }
    }
    if (form.paymentMethod === 'Other') {
      return {
        amount: pricing.total.amount,
        method: PaymentMethodInput.Other,
        other: otherPayment(form, otherPaymentCategory),
      };
    }
    // TODO error handling in next MR
    throw new Error('payment not supported');
  };
};
